import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasePageComponent } from '../../pages/base.page';
import { UserRoles } from '../../shared/enum/userrole.enum';
import { localizationKeys } from './../../utils/localizationKeys';

@Component({
    selector: 'app-page-customers-overview',
    templateUrl: './customers-overview.page.html',
    styleUrls: ['./customers-overview.page.scss'],
})
export class CustomersOverviewPage extends BasePageComponent implements OnInit {
    localizationKeys = localizationKeys;
    roles = [UserRoles.SUPER_ADMIN];
    constructor(injector: Injector, protected override router: Router) {
        super(injector);
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    hasReadPermission(): boolean {
        return true;
    }

    hasWritePermission(): boolean {
        return true;
    }
}
